module.exports = __webpack_public_path__ + "img/icon.fc27d8e2.png";